
import { SET_RED_BAR_DISPLAYED } from '../constants/actionTypes';


export const setRedBarDisplayed = (isShowingBar) => {
  return {
    type: SET_RED_BAR_DISPLAYED,
    isShowingBar
  };
}